import { ref } from 'vue'
import { defineStore } from 'pinia'
import tga from 'thinkingdata-browser'

export const useTgaStore = defineStore('tga', () => {
  const event = ref('') // 活动标识
  const account = ref('') // 用户账号
  // tga配置
  const pack = {
    dev: {
      appid: "90e0c81c4bd84cc0a49852ba51c739ae",
      serverUrl: "https://tga-new-collect-s.racoondigi.cn"
    },
    product: {
      appid: 'b2cd217a0bf7437d9ff88dafe8b2d36f',
      serverUrl: 'https://tga-new-collect-s.racoondigi.cn'
    }
  }

  // tga初始化
  function tgaInit() {
    tga.init({
      appId: pack['dev'].appid,
      serverUrl: pack['dev'].serverUrl,
      showLog: false
    })
  }

  // tga登录
  function tgaLogin(e, a) {
    event.value = e
    account.value = a
    tga.login(account.value)
  }

  // 事件上传
  function tgaTrack(e, data) {
    tga.track(e, {
      game: 'JQYS',
      web_event: event.value,
      account: account.value,
      ...data
    })
  }
  return { tgaInit, tgaLogin, tgaTrack }
})
